export interface MyAccountForm {
  buttonLabel?: string;
  color?: string;
  fieldLabel?: string;
  href: string;
  icon: string;
  label: string;
  passwordPolicy?: Array<PasswordPolicy>;
  title?: string;
  type?: string;
  subMenu?: Array<MyAccountForm>;
}

export interface PasswordPolicy {
  regex: string;
  message: string;
  validated?: boolean;
}

export enum MyAccountFormTypes {
  MY_ACCOUNT_PASSWORD = 'my-account-password',
  MY_ACCOUNT_TOS = 'my-account-tos',
  MY_ACCOUNT_PRIVACY_POLICY = 'my-account-privacy-policy',
  MY_ACCOUNT_DOCUMENT = 'my-account-document',
  MY_ACCOUNT_USER_PREFERENCE = 'my-account-user-preference',
  MY_ACCOUNT_HELP = 'my-account-help-support',
  MY_ACCOUNT_TERMS_OF_USE = 'my-account-terms-of-use',
  MY_ACCOUNT_SECURITY_ACCESS = 'my-account-security-access',
  MY_ACCOUNT_SIGNED_DOCUMENT = 'my-account-signed-documents'
}

export interface Attachment {
  name: string;
  href: string;
}

export interface AttachmentInfo {
  icon?: string;
  contentType?: string;
  fileType?: string;
  sectionLabel: string;
  attachment: Attachment | Array<Attachment>;
}

export interface documentDetails {
  title: string;
  label: string;
  current: AttachmentInfo;
  previous?: AttachmentInfo;
  buttonLabel?: string;
  removeSectionLabel?: string;
  removeSectionDescription?: string;
}

export interface PageDetail {
  title: string;
  icon: string;
  pageType: string;
}
